import React, { Component } from "react";
import { Layout } from "antd";
const { Footer } = Layout;
class FooterTemplate extends Component {
  render() {
    return (
      <Footer style={{ textAlign: "center" }}>
        <a href="https://wecommit.com.vn/">
          Website được phát triển và vận hành bởi công ty WECOMMIT
          <br></br>
          Phiên bản 1.0
        </a>
      </Footer>
    );
  }
}

export default FooterTemplate;